/**
 * Smoothly scroll to the element for the given hash (or current window.location.hash).
 * Uses scrollIntoView so scroll-margin-top (set in CSS) handles the fixed navbar offset.
 * @param {string} [hashOverride] - If provided, use this instead of reading from window.location.hash
 */
export function scrollToHash(hashOverride) {
  const hash = (
    hashOverride ??
    (window.location.hash || "").replace(/^#/, "")
  ).toLowerCase();
  if (!hash || hash === "page-top") {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  const el = document.getElementById(hash);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
